import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-modal-mercado',
  templateUrl: './modal-mercado.component.html',
  styleUrls: ['./modal-mercado.component.scss']
})
export class ModalMercadoComponent implements OnInit, OnChanges {
  @Input() urlMercadoPago: any;
  @Input() activeModal: boolean = false;

  @ViewChild('openMercadoPago') openMercadoPago!: any;
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.activeModal) {
      this.openMercadoPago.nativeElement.click();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
   
    if (this.activeModal) {
      this.openMercadoPago.nativeElement.click();
    }
  }

}
